import React, { CSSProperties, FC, useState } from 'react';
import {
  Carousel as BaseCarousel,
  CarouselControl,
  CarouselIndicators,
  CarouselItem,
} from 'reactstrap';

export interface CarouselProps extends React.HTMLAttributes<HTMLElement> {
  activeIndex?: number;
  fade?: boolean;
  items: Array<Pick<HTMLImageElement, 'src' | 'alt'> & { style?: CSSProperties }>;
}

const Carousel: FC<CarouselProps> = props => {
  const { activeIndex: defaultActiveIndex = 0, fade, items, className } = props;

  const [activeIndex, setActiveIndex] = useState(defaultActiveIndex);
  const [animating, setAnimating] = useState(false);

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex: number) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  return (
    <BaseCarousel
      fade={fade}
      activeIndex={activeIndex}
      next={next}
      previous={previous}
      className={className}
    >
      {items.length > 1 && (
        <CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={goToIndex} />
      )}
      {items.map(item => (
        <CarouselItem
          onExiting={() => setAnimating(true)}
          onExited={() => setAnimating(false)}
          key={item.src}
        >
          <img
            src={item.src}
            alt={item.alt}
            className="d-block mx-auto"
            style={{ maxWidth: '100%', maxHeight: 'calc(100vh - 80px)', ...item.style }}
          />
        </CarouselItem>
      ))}
      {items.length > 1 && (
        <>
          <CarouselControl
            className="opacity-75"
            direction="prev"
            directionText="Previous"
            onClickHandler={previous}
          />
          <CarouselControl
            className="opacity-75"
            direction="next"
            directionText="Next"
            onClickHandler={next}
          />
        </>
      )}
    </BaseCarousel>
  );
};

export default Carousel;
